import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/** NLT / SLT / ELT scores read from the client's shared Score categorisation spreadsheet.
 *  Refreshed once a day server-side; `refresh()` forces a re-read on demand. */
export const useDinacharyaScores = () => {
  const { tenantId } = useAuth();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!tenantId) return;
    try {
      const { data: d } = await api.get(`/tenants/${tenantId}/dinacharya/scores`);
      setData(d);
    } catch (e) { setData({ source_configured: false, levels: [], error: errMsg(e) }); }
  }, [tenantId]);

  useEffect(() => { load(); }, [load]);

  const refresh = async () => {
    setBusy(true);
    try {
      const { data: d } = await api.post(`/tenants/${tenantId}/dinacharya/scores/refresh`);
      setData(d);
      toast.success("Scores re-read from the spreadsheet");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return { scores: data, refresh, busy };
};
